import React from "react";
import PropTypes from "prop-types";
import DocumentScoringContainer from "features/document/edit/scoring/components/DocumentScoringContainer";

const OfferScoringContainer = ({ documentId, siteId, history }) => {
  const viewScoringHistory = () => {
    history.push(`/offers/${documentId}/${siteId}/historyscoring`);
  };

  return (
    <DocumentScoringContainer
      documentId={documentId}
      siteId={siteId}
      viewScoringHistory={viewScoringHistory}
      isFolder={false}
    />
  );
};

OfferScoringContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  history: PropTypes.object.isRequired
};

export default OfferScoringContainer;
